export enum ChangeType {
  Added = 'Added',
  Removed = 'Removed',
}

export const CLASSES = {
  CONTAINER: 'EmailsInputWrapper',
  EMAIL: 'EmailsInput-email',
  INPUT: 'EmailsInput-input',
  WRAPPER: 'EmailsInput',
};
